import React from 'react'
import PropTypes from 'prop-types'
import { Dropdown, Button, Popconfirm, message } from 'antd'
import { Link } from 'react-router-dom'
import { DownOutlined } from '@ant-design/icons'
import { useLocalization } from '@contexts/LocalizationContext'
import { client } from '@utils/client'
import Text from '@components/Text'

const ListOperation = ({
  row,
  basePath,
  isEdit = true,
  isDelete = true,
  isView = true,
  deletePath,
  handleReload,
}) => {
  const { t } = useLocalization()
  const viewOnly = !isEdit && !isDelete
  const deleteOnly = !isEdit && !isView
  const onDelete = async () => {
    try {
      await client.delete(deletePath)
      message.success(t('components.listOperation.deleteSuccess'))
      handleReload()
    } catch (e) {
      message.error(t('components.listOperation.deleteFailed'))
    }
  }

  const items = [
    {
      label: (
        <Link to={`${basePath}/${row.id}/edit`}>
          <Text type="primary">{t('components.listOperation.edit')}</Text>
        </Link>
      ),
      key: '1',
    },
    {
      type: 'divider',
    },
    {
      label: (
        <Popconfirm
          title={t('components.listOperation.deleteConfirmQuestion')}
          okText={t('components.listOperation.okText')}
          cancelText={t('components.listOperation.cancelText')}
          onConfirm={onDelete}
        >
          <Text type="primary">{t('components.listOperation.delete')}</Text>
        </Popconfirm>
      ),
      key: '2',
    },
  ]

  if (viewOnly) {
    return (
      <Button>
        <Link to={`${basePath}/${row.id}`}>
          {t('components.listOperation.view')}
        </Link>
      </Button>
    )
  }

  if (deleteOnly) {
    return (
      <Popconfirm
        title={t('components.listOperation.deleteConfirmQuestion')}
        okText={t('components.listOperation.okText')}
        cancelText={t('components.listOperation.cancelText')}
        onConfirm={onDelete}
      >
        <Button type="primary" danger>
          {t('components.listOperation.delete')}
        </Button>
      </Popconfirm>
    )
  }

  return (
    <Dropdown.Button menu={{ items }} icon={<DownOutlined />}>
      <Link to={`${basePath}/${row.id}`}>
        {t('components.listOperation.view')}
      </Link>
    </Dropdown.Button>
  )
}

ListOperation.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string,
  }),
  basePath: PropTypes.string,
  isEdit: PropTypes.bool,
  isDelete: PropTypes.bool,
  isView: PropTypes.bool,
  deletePath: PropTypes.string,
  handleReload: PropTypes.func,
}

export default ListOperation
